export default __webpack_public_path__ + "f1e109cf5e1a921904b9b11a4f581d07.png";